var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-box"},[_vm._m(0),_c('div',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-roller"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }